module.exports = __webpack_public_path__ + "media/promo/courses/images/herodec-d81d227c9f3525dc1ba60e8f33179518.png";